import script from "./PlaylistsCollections.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlaylistsCollections.vue?vue&type=script&lang=ts&setup=true"

import "./PlaylistsCollections.vue?vue&type=style&index=0&id=137a7867&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137a7867"]])

export default __exports__